import { useQuery } from "@tanstack/react-query";

import { VocabularyWordSummary } from "@seneca/course-service-types";

import { fetchWords } from "seneca-common/features/course/service";
import {
  FetchHookParams,
  FetchHookResult
} from "seneca-common/utils/hooks/fetch/fetchHookUtils";

const getQueryKey = ({ wordIds }: { wordIds: string[] }) => [
  "fetchWords",
  wordIds
];

type Params = FetchHookParams<{
  wordIds: string[];
}>;

type Result = FetchHookResult<VocabularyWordSummary[]>;

export default function useFetchWords({
  fetchParams,
  enabled = true
}: Params): Result {
  return useQuery({
    queryKey: getQueryKey(fetchParams),
    queryFn: () => fetchWords(fetchParams),
    staleTime: Infinity,
    enabled: enabled && fetchParams.wordIds.length > 0
  });
}
